const NS = 'WysiwygBlock';
const CLS = 'wysiwygBlock';

export class WysiwygBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.initResponsiveTables();
	}

	// Wrap a div.table-responsive class to have responsive tables
	initResponsiveTables() {
		this.$element.find('table').wrap(`<div class='table-responsive'></div>`).before('<div class="table-spacer"></div>').after('<div class="table-spacer"></div>');
	}
}
